import common from './common';
import main from './main';

const zhHant = { common, main };
export default zhHant;
